import { FC } from 'react';

import { Regular } from '@zazume/zzm-base';

import { BasicUserFieldSkeleton } from '#/components/skeleton/atoms/BasicUserFieldSkeleton';
import { TableSkeleton } from '#/components/skeleton/atoms/TableSkeleton';

type SkeletonProps = FC & {
  Table: typeof TableSkeleton;
  BasicUserField: typeof BasicUserFieldSkeleton;
};

export const Skeleton: SkeletonProps = () => {
  return (
    <>
      <Regular.Skeleton />
    </>
  );
};

Skeleton.Table = TableSkeleton;
Skeleton.BasicUserField = BasicUserFieldSkeleton;
